<!-- 内部用户快捷上报 -->
<template>
    <div v-show="data.loading">
        <nut-overlay v-model:visible="data.loading" :lock-scroll="true">
            <div class="wrapper">
                <nut-icon name="loading" size="32px"></nut-icon>
            </div>
        </nut-overlay>
    </div>
    <div class="batch_header" v-if="!data.isH5">
        <img src="@/assets/image/图标-20.png" alt="" @click="backEvent" />
        <div>快捷上报</div>
    </div>
    <div v-if="data.isAuditNoPass" class="auditNoPass">
      <img src="../../assets/image_message_appear/iconError@2x.png" alt />
      <div>不合格原因｜{{ data.checkDescription }}</div>
    </div>
    <div class="batch_report_box">
        <div class="mgTp16">
            <div class="detail_title">1.类型选择</div>
            <div :class="store.state.isH5 ? 'mgTp4 wayPassStatus': 'mgTp4 wayPassStatus'">
                <div style="padding-top:16Px">
                    <button
                        v-for="item in data.typeSelectList" 
                        :key="item.label"
                        @click="e => PassStatusEvent(item.label, e)"
                        :class="[item.select ? 'activeBtn card--active':'defaultBtn']"
                    >
                         {{ item.label == '地点信息更改' ? '信息修改' : item.label }}
                        <t-icon v-if="item.select" name="check" class="card__icon" :aria-hidden="true" />
                    </button>
                </div>
            </div>
        </div>
        <div class="mgTp20" v-if="descriptionComputed.show">
            <div class="description_textarea">补充说明</div>
            <div style="margin-top: 12px;">
                <div>
                    <textarea class="goOnInfo" style="margin-bottom: 0;" 
                        v-if="!data.userCheckDetail"
                        maxlength="50" v-model="data.formData.descriptiontextarea"
                        @focus="fillInBtnShowOrHidden"
                        :placeholder="descriptionComputed.placeholder">
                    </textarea>
                    <div class="goOnInfo" style="margin-bottom: 0;" v-else>{{ data.formData.descriptiontextarea }}</div>
                </div>
            </div>
        </div>
        <div class="mgTp24">
            <div class="detail_title">2.现场视频<span class="redPoint"></span></div>
            <div class="mgTp6">
                <div>
                    <div class="advise_photo_info mbBm13">请拍摄您要反馈的区域视频，尽量缓慢移动，保持图片清晰完整。(小鹅提示：您也可以开启语音权限边拍边说明情况哦~)</div>
                    <photoVue :list="data.formData.infoVideos" @deletePic="photoDeletePic" :number="store.state.isH5 ? 6 : 3"
                        @previewImg="photoPreviewImg" ref="infoVideos" type="video"
                        @photoadd="photoaddwx"
                        :userCheckDetail="data.userCheckDetail" :isSetLimit="true"  listType="infoVideos" :latlng="data.photoLatLng"
                        :userLocation="data.userLocation" :pageType="data.pageType" />
                </div>
            </div>
        </div>
        <div class="mgTp24" v-if="(data.userCheckDetail && data.formData.voiceNote != '') || !data.userCheckDetail">
            <div class="detail_title mbBm13">备注</div>
            <div>
                <div>
                    <textarea class="goOnInfo" v-if="!data.userCheckDetail" 
                        maxlength="50" v-model="data.formData.voiceNote"
                        @focus="fillInBtnShowOrHidden"
                        placeholder="您还可以补充描述其他需要反馈的信息，感谢您的参与！">
                    </textarea>
                    <div class="goOnInfo" v-else>{{ data.formData.voiceNote }}</div>
                </div>
            </div>
        </div>
        <div v-else style="height: 150px;"></div>
        <div :class="['appeared', data.isShowFillInBtn ? 'showFillinBtn' : 'hiddenFillinBtn']">
            <button v-if="!data.userCheckDetail" @click="FillInEvent"
                :class="[data.userFillInComplete ? 'complete ' : '']">完成上报</button>
            <button v-else @click="backEvent" :class="data.userFillInComplete ? 'complete ' : ''">返回</button>
        </div>
    </div>
    <previewImage v-if="data.showPreviewImg" :showPreviewVideo="data.showPreviewVideo" :source="data.sourceVideo"
        :showPreviewImg="data.showPreviewImg" :photoList="data.previewImageList" :initPage="0"
        :isViewExample="data.isViewExample" @setShowPreviewVideo="getShowPreviewVideo"
        @setShowPreviewImg="getShowPreviewImg">
    </previewImage>
    <div class="dialogObscuration" v-if="$store.state.messageAppearDetailVisble">
        <div class="dialogImg">
            <span @click="dialogCancle"></span>
            <span @click="dialogOk"></span>
        </div>
    </div>
    <nut-overlay v-model:visible="data.notAllowReport" z-index="1000" :lock-scroll="true" :close-on-click-overlay="false">
        <div class="wrapper_overlay">
            <div class="content">{{ data.notAllowReportText }}</div>
        </div>
    </nut-overlay>
</template>
<script setup>
import { 
    reactive,
    ref,
    onBeforeMount,
    watch,
    computed,
    onUnmounted,
    onMounted
} from 'vue';
import { useRouter, onBeforeRouteLeave, useRoute } from 'vue-router';
import photoVue from '../../components/photo.vue';
import previewImage from "../../components/previewImage";
import cosPutObject from '../cosPutObject.js'
// import cosGetObjectUrl from '../cosGetObjectUrl'
import { useStore } from 'vuex';
import request from '../../utils/request';
// import wx from 'weixin-js-sdk';
import * as api from '../../utils/api'
import { Notify } from '@nutui/nutui';
import { 
    toYYMMDDHMS, 
    // isPlatformPC 
} from '../../utils/utils' 
import {
    newAddLocationList,
    radioSelect,
} from '../config'
// import {
//     getLocation,
//     getUserLocationInfo
// } from '../heartReport'
const Cos = require("cos-js-sdk-v5");
// 获取拍摄视频的dom ref
const infoVideos = ref(null)
const router = useRouter()
const route = useRoute()
const store = useStore()
const cos5 = new Cos({
    getAuthorization: function(options, callback) {
        request("post", api.getCosCredentialsByScene, {
            scene: 'info_report',
            ext_info: {
                openid: store.state.userOpenId
            }
        })
        .then(data => {
            callback({
                TmpSecretId: data.data.credentials.tmp_secret_id,
                TmpSecretKey: data.data.credentials.tmp_secret_key,
                SecurityToken: data.data.credentials.session_token,
                ExpiredTime: data.data.credentials.expired_time
            });
        });
    }
});
const data = reactive({
    userCheckDetail: false, // 是否是查看
    // 类型选择
    typeSelectList: newAddLocationList,
    formData: {
        zoneDescription: '', // 已知-固定为 空 
        description:'', // 类型选择 + 补充说明
        descriptiontextarea: '', // 补充说明-textarea
        // 视频资料——拍视频
        infoVideos: [
            {
                index: 1,
                src: '',
                type: 'infoVideos',
                srcCopy: '',
                title: '周边视频',
                tracks: [],
                start_time: '',
                end_time: '',
                text: '',
                poster: 'https://img1.baidu.com/it/u=2781281637,4119398334&fm=253&fmt=auto&app=138&f=JPEG?w=80&h=80'
            }
        ],
        voiceNote: '', // 备注
        isInnerUser: '', // 是否是内部用户
        phone: '', // 用户手机号
    },
    isAuditNoPass: false, // 是否审核不合格
    checkDescription: '', // 审核不合格原因
    firstSubmitEvent: true, // 是否是第一次提交 
    isViewExample: false,// 浏览图片时是否是示例
    previewImageList: [],// 展示图片列表
    sourceVideo: {}, // 视频
    showPreviewVideo: false, // 是否展示视频
    showPreviewImg: false, // 是否展示浏览
    // 是否允许退出
    isAllowExit: false,
    // 是否展示遮罩层
    loading: false,
    userFillInComplete: false, // 用户是否填写完成
    pageType: 4, // 上报类型
    isShowFillInBtn: true, // 是否展示完成上报按钮
    judge: null, // 存储同  isshare ?
    showDescriptionIcon: false, // 是否展示问题描述的删除按钮
    notAllowReportText: '', // 弹框展示内容
    notAllowReport: false, // 是否展示弹框
    isH5: false,
    heartLatLng: {
        lat: '',
        lng: '',
        direction: '',
        adcode: '',
        accuracy: '',
    },
    lastTime: new Date().getTime(),
    getlocationInterval: null,
    heartList: [],
    timestamp: '',
});
data.isH5 = store.state.isH5;
console.log(data.isH5, '快捷上报');
const descriptionComputed = computed(() => {
    console.log(data.formData.description);
    if(data.formData.description != ''){
        const a = data.formData.description.includes('地点不存在')
        const b = data.formData.description.includes('地点信息更改')
        if(a && b){
            return {
                show: true,
                placeholder: '请描述不存在、需要信息修改的具体店铺名称和对应内容'
            }
        }else if(a){
            return{
                show: true,
                placeholder: '请描述不存在的具体店铺名称'
            }
        }else if(b){
            return{
                show: true,
                placeholder: '请描述需要信息修改的具体店铺名称和对应内容'
            }
        }else{
            return {
                show: false,
                placeholder: ''
            }
        }
    }else{
        return{
            show: false,
            placeholder: ''
        }
    }
}, [data.formData.description])
onBeforeMount(() => {
    // if(store.state.isH5 && isPlatformPC()){
    //     wx.miniProgram.switchTab({
    //         url: '/pages/userHomePage/userHomePage'
    //     })
    //     return
    // }
    // if(store.state.isH5){
    //     getLocation().then(res => {
    //         // console.log(res, 'res')
            
    //         getUserLocationInfo({
    //             lat: res.lat,
    //             lng: res.lng,
    //             type: 'adcode'
    //         }).then(adcode => {
    //             console.log(adcode, 'adcode');
    //             data.heartLatLng = {
    //                 ...data.heartLatLng,
    //                 lat: res.lat,
    //                 lng: res.lng,
    //                 // direction: res.direction,
    //                 adcode: adcode.slice(0, 4) + '00'
    //             }
    //             heartbeatFun()
    //         }).catch(err => {
    //             console.log(err, 'err-adcode');
    //             data.heartLatLng = {
    //                 ...data.heartLatLng,
    //                 lat: res.lat,
    //                 lng: res.lng,
    //                 // direction: res.direction
    //             }
    //         })
    //     }).catch(err => {
    //         console.log(err, 'err-getlocation');
    //     })
    //     // 获取经纬度
    //     data.getlocationInterval = setInterval(() => {
    //         getLocation().then(res => {
    //             console.log(res, 'getlocation--res')
    //             data.heartLatLng = {
    //                 ...data.heartLatLng,
    //                 lat: res.lat,
    //                 lng: res.lng,
    //                 // direction: res.direction
    //             }
    //             heartbeatFun()
    //         }).catch(err => {
    //             console.log(err, 'err');
    //         })
    //     }, 2000)
    //     // 监听设备方向
    //     getDeviceorientation()
    // }
    console.log(route.params);
    data.typeSelectList.map(item => item.select = false)
    if (route.params.from == 'index') {
        data.userCheckDetail = false
    } else if (route.params.from == "history") {
        data.userCheckDetail = true
        data.userFillInComplete = true
        data.loading = true
        if(route.params.auditStatus === "未通过"){
            data.isAuditNoPass = true
            data.checkDescription = route.params.checkDescription;
            const radio_select = JSON.parse(route.params.innerCheckResult).radio_select
            // 银河审核不合格
            if(radio_select != 0){
                data.checkDescription = radioSelect.filter(item => item.key == radio_select)[0].value
            }
        }
        getReportData(route.params.cosUrl)
    }
    if(window.easyearn){
        const obj = JSON.parse(window.easyearn.getUserLocation())
        if(obj.latitude == 0 && obj.longitude == 0) {
            data.notAllowReportText = '请开启定位权限'
            data.notAllowReport = true
            data.isAllowExit = true
            return
        }
    }
})
onUnmounted(() => {
    console.log('onUnmounted');
    clearInterval(data.getlocationInterval) 
    data.getlocationInterval = null 
    // var ua = navigator.userAgent.toLowerCase();
    // if(/android/.test(ua)) {
    //     window.removeEventListener("deviceorientationabsolute", deviceorientationabsoluteFun)
    // }else{
    //     window.removeEventListener("deviceorientation", deviceorientationFun)
    // }
    // window.removeEventListener("compassneedscalibration", compassneedscalibrationFun)
})
onMounted(() => {
    data.timestamp = new Date().getTime() + ''; // 时间戳
})
// const heartbeatFun = () => {
//     const params = {
//         accuracy: Number(data.heartLatLng.accuracy),
//         city_code: data.heartLatLng.adcode,
//         direction: Number(data.heartLatLng.direction),
//         gps_time_in_ms: new Date().getTime(),
//         sys_time_in_ms: new Date().getTime(),
//         user_location: {
//             x: Number(data.heartLatLng.lat),
//             y: Number(data.heartLatLng.lng)
//         },
//         version: '1.0.0'
//     }
//     console.log(params, '心跳params');
//     data.heartList.push(params)
//     request("post", api.heartbeat, params)
// }
// const deviceorientationabsoluteFun = (event) => {
//     const nowTime = new Date().getTime();
//     // console.log(event, 'deviceorientationabsolute222');
//     if(nowTime - data.lastTime > 1000){
//         data.lastTime = nowTime;
//         console.log(2222222, '安卓', event, event.alpha + " : " + event.beta + " : " + event.gamma);
//         data.heartLatLng = {
//             ...data.heartLatLng,
//             direction: event.alpha
//         }
//     }
// }
// const deviceorientationFun = (event) => {
//     const nowTime = new Date().getTime();
//     console.log(event, 'deviceorientationabsolute111');
//     if(nowTime - data.lastTime > 1000){
//         data.lastTime = nowTime;
//         console.log(111111, 'ios', 360 - event.webkitCompassHeading);
//         data.heartLatLng = {
//             ...data.heartLatLng,
//             direction: 360 - event.webkitCompassHeading
//         }
//     }
// }
// const compassneedscalibrationFun = (event) => {
//     Toast.text('您的罗盘需要校准，请将设备沿数字8方向移动。');
//     event.preventDefault();
// }
// const getDeviceorientation = () => {
//     window.addEventListener("compassneedscalibration", compassneedscalibrationFun, true);
//     var ua = navigator.userAgent.toLowerCase();
//     console.log(ua, /android/.test(ua));
//     if(/android/.test(ua)) {
//         window.addEventListener("deviceorientationabsolute", deviceorientationabsoluteFun, true);
//     } else {
//         window.addEventListener("deviceorientation", deviceorientationFun, true);
//     }
    
// }
const getReportData = (url) =>{
    // let key = url.split(".com/")[1];
    // const judge = url.indexOf('ishare-10003415')
    const url2 = url.includes('http') ? url : `https://${url}`
    window.getReadOnlyPresignedUrlApi(url2).then(resUrl => {
        request("get", resUrl).then(res => {
            console.log(res, 'res');
            if(res){
                const body = res
                data.typeSelectList.map(item => item.select = false)
                body.description.split('。')[0].split(',').map(description => {
                    data.typeSelectList.map(type => {
                        if(type.label == description){
                            type.select = true
                        }
                    })
                })
                data.formData['description'] = body.description.split('。')[0]
                data.formData['descriptiontextarea'] = body.description.split('补充说明：')[1]
                data.formData['voiceNote'] = body.voiceNote
                data.formData['infoVideos'] = []
                data.loading = false
                body.infoVideos.map((item, index) => {
                    let obj = {
                        index: index + 1,
                        src: item.url,
                        type: 'infoVideos',
                        srcCopy: item.url,
                        title: '周边视频',
                        tracks: [],
                        start_time: '',
                        end_time: '',
                        text: '',
                        poster: 'https://img1.baidu.com/it/u=2781281637,4119398334&fm=253&fmt=auto&app=138&f=JPEG?w=80&h=80'
                    }
                    data.formData['infoVideos'].push(obj)
                    recivePicPathGetUrl(item.url, index, 'infoVideos')
                })
            }else{
                data.loading = false
                Notify.text('获取上报信息错误')
                return
            }
        })
    })
}
const photoDeletePic = ({ title: type, index }) => {
    const value = type
    const arr = data.formData[type].filter(item => (item.type == type && item.src !== ''));
    if (type == 'infoVideos') {
        let arrLength = store.state.isH5 ? 6 : 3
        // 拍视频
        if (arr.length == arrLength) {
            data.formData[value].splice(index, 1)
            data.formData[value].push({
                index: data.formData[value].length + 1,
                src: '',
                srcCopy: '',
                type: 'infoVideos',
                title: '拍视频',
                tracks: [],
                start_time: '',
                end_time: '',
                text: '',
                poster: 'https://img1.baidu.com/it/u=2781281637,4119398334&fm=253&fmt=auto&app=138&f=JPEG?w=80&h=80'
            })
        } else {
            data.formData[value].splice(index, 1)
        }
        const length = data.formData.infoVideos.length
        new Array(length).fill(0).map((_, index) => {
            infoVideos.value.logList(data.formData[value][index].src, index)
        })
    }

}
const photoaddwx = (res) => {
    console.log(res[0].url, res);
    let arr = []
    res.forEach(item => {
        arr.push({
            lat: String(item.lat),
            lng: String(item.lng),
            timestamp: String(item.time),
            angle: String(item.direction)
        })
    })
    // const timeArr = res.sort((a, b) =>  a.time - b.time)
    console.log(toYYMMDDHMS(res[0].lastModified - res[0].duration), toYYMMDDHMS(res[0].lastModified));
    data.judge = res[0].url.indexOf('ishare-10003415')
    const length = data.formData['infoVideos'].length
    data.formData['infoVideos'][length - 1] = {
        ...data.formData['infoVideos'][length - 1],
        src: res[0].url,
        srcCopy: res[0].url,
        tracks: arr,
        start_time: toYYMMDDHMS(res[0].lastModified - res[0].duration),
        end_time: toYYMMDDHMS(res[0].lastModified),
    }
    recivePicPathGetUrl(res[0].url, length - 1, 'infoVideos');
    let arrLength = store.state.isH5 ? 6 : 3
    if (data.formData.infoVideos.length < arrLength) {
        data.formData['infoVideos'].push({
            index: data.formData['infoVideos'].length + 1,
            src: '',
            srcCopy: '',
            title: '周边视频',
            type: 'infoVideos',
            tracks: [],
            start_time: '',
            end_time: '',
            text: '',
            poster: 'https://img1.baidu.com/it/u=2781281637,4119398334&fm=253&fmt=auto&app=138&f=JPEG?w=80&h=80'
        })
    }
    console.log(data.heartList, 'data.heartList');
}
window.getParameter = () => {
      // data.showPreviewImg = val;
      console.log(data.timestamp);
      return data.timestamp;
    };
// 检测用户填写
watch(() => [data.formData], newV => {
        let bool = true;
        console.log(newV, 'newv');
        Object.keys(newV[0]).map(item => {
            if (item == 'description') {
                if (newV[0][item] == '' || newV[0][item] == undefined) {
                    bool = false
                }
            }
            if (item == 'descriptiontextarea') {
                if (newV[0]['description'].includes('地点不存在') && newV[0][item] == '') {
                    bool = false
                }
            }
            if (item == 'infoVideos') {
                if (newV[0][item][0].src == '') {
                    bool = false
                }
            }
        })
        data.userFillInComplete = bool 
    },{
        deep: true,
    }
)
// 上报
const FillInEvent = async () => {
    if (!validtor()) return 
    if (data.userFillInComplete == false) return
    if (data.userCheckDetail) {
        router.go(-1)
    } else{
        if (data.firstSubmitEvent == false) return
        data.firstSubmitEvent = false;
        data.loading = true
        const infoVideos = []
        data.formData.infoVideos.map(item => {
            if(item.srcCopy != ''){
                let obj = {
                    url: item.srcCopy.includes('http') ? item.srcCopy : 'https://' + item.srcCopy,
                    tracks: item.tracks,
                    start_time: item.start_time,
                }
                if(store.state.isH5){
                    obj.end_time = item.end_time,
                    obj.dataSource = 1
                }
                console.log(obj, 'isH5-obj');
                infoVideos.push(obj)
            }
        })
        const obj = {
            voiceNote: data.formData.voiceNote,
            zoneDescription: data.formData.zoneDescription,
            description: data.formData.description == '地点新增。' ?  data.formData.description : 
            data.formData.description + '补充说明：' + data.formData.descriptiontextarea,
            infoVideos,
            isInnerUser: store.state.isInternalUser ? '1' : '0',
        }

        console.log(obj);
        let lnglat;
        if(store.state.isH5) {
            obj.dataSource = '1';
            obj.phone = store.state.userPhone;
            lnglat = store.state.location;
        } else {
            lnglat = JSON.parse(window.easyearn.getUserLocation());
            obj.phone = window.easyearn.getPhoneNumber();
        }
        const key = `easyearn/info_report/${store.state.userOpenId}/poi/huitu_activity_fe/newBatchReport/${new Date().getTime()}.json`;
        cosPutObject(data.judge, key, obj, cos5).then(async res => {
            console.log(res, 'res');
            const objReport = {
                pId: '',
                reportName: data.formData.zoneDescription,
                reportType: 7, // 固定
                subType: null,
                cosUrl: `http://${res.Location}`,
                confId: null,
                adcode: null,
                sourceFrom: store.state.isH5 ? 2 : 1, // 1 app 2 小程序
                common: {
                    version: "3.16.0",
                    module_id: "2",
                    vcode: "31600000",
                    loc_x: lnglat.latitude || '39.984120',
                    loc_y: lnglat.longitude || '116.307484',
                }
            }
            console.log(objReport);
            const infoReportRes = await request("post", api.infoReport, objReport)
            console.log(infoReportRes, 'infoReportRes');
            if (infoReportRes.code == 0) {
                data.firstSubmitEvent = true;
                data.loading = false
                data.isAllowExit = true
                router.replace('/report_success')
            } else if (infoReportRes.code !== 0) {
                data.firstSubmitEvent = true;
                data.loading = false
                Notify.warn("上报失败，请重试");
            }
        }).catch(err => {
            console.log(err, 'err-fillinevent');
            data.firstSubmitEvent = true;
            data.loading = false
        })
        data.isAllowExit = true
    }
}
// 校验
const validtor = () => {
    let bool = true
    Object.keys(data.formData).map(item => {
        const element = data.formData[item]
        if(item == 'description' && element == ''){
            Notify.text("请填写问题说明");
            bool = false;
            return
        }else if(item == 'infoVideos' && element[0].src == ''){
            Notify.text("请拍摄视频");
            bool = false;
            return
        }else if(item == 'descriptiontextarea' && (data.formData['description'].includes('地点不存在') && element == '')){
            Notify.text("请填写补充说明");
            bool = false;
            return
        }
    })
    return bool
}
// 浏览图片和视频
const photoPreviewImg = ({ type, title: formDataKey, current, url }) => {
    if (type !== '示例') {
        data.formData[formDataKey].map((item, mapIndex) => {
            if (item.type == formDataKey && current == mapIndex) {
                data.previewImageList = [{
                    src: item.src
                }]
                if (type == '视频') {
                    data.sourceVideo = {
                        src: item.src,
                        type: 'video/mp4'
                    }
                }
            }
        })
    }
    if (type == '示例') {
        data.previewImageList = [url]
        data.isViewExample = true
    } else {
        data.isViewExample = false
    }
    if (type == '视频') {
        data.showPreviewVideo = true
    }
    data.showPreviewImg = true
}
const getShowPreviewVideo = val => {
    data.showPreviewVideo = val;
};
const PassStatusEvent = (label) => {
    if(data.userCheckDetail) return
    data.typeSelectList.map(item => item.label == label ? item.select = !item.select : null)
    const arr = data.typeSelectList.filter(item => item.select == true).map(item => item.label)
    data.formData.description = arr.length > 0 ? arr.join(',') + '。' : ''
    if(!(arr.includes('地点不存在') || arr.includes('地点信息更改'))){
        data.formData.descriptiontextarea =  '';
    }
}
// 输入时隐藏上报按钮
const fillInBtnShowOrHidden = () => {
    if ( /Android/gi.test(navigator.userAgent)) {
        const innerHeight = window.innerHeight;
        window.addEventListener('resize',()=>{
            const newInnerHeight = window.innerHeight;
            if ( innerHeight > newInnerHeight) {
                //键盘弹出事件处理
                data.isShowFillInBtn = false
            }else {
                //键盘收起事件处理
                data.isShowFillInBtn = true
            }
        });
    }else {
        window.addEventListener('focusin ',() =>{//键盘弹出事件处理
            data.isShowFillInBtn = false
        });
        window .addEventListener('focusout',()=>{//键盘收起事件处理
            data.isShowFillInBtn = true
        });
    }
}
// 拍摄视频
window.shootVideoCallback = ({url, locations}) => {
    console.log(url, locations);
    let arr = []
    locations.forEach(item => {
        arr.push({
            lat: String(item.lat),
            lng: String(item.lng),
            timestamp: String(item.time),
            angle: String(item.direction)
        })
    })
    const timeArr = locations.sort((a, b) =>  a.time - b.time)
    data.judge = url.indexOf('ishare-10003415')
    const length = data.formData['infoVideos'].length
    data.formData['infoVideos'][length - 1] = {
        ...data.formData['infoVideos'][length - 1],
        src: url,
        srcCopy: url,
        tracks: arr,
        start_time: toYYMMDDHMS(timeArr[0].time),
    }
    recivePicPathGetUrl(url, length - 1, 'infoVideos');
    let arrLength = store.state.isH5 ? 6 : 3
    if (data.formData.infoVideos.length < arrLength) {
        data.formData['infoVideos'].push({
            index: data.formData['infoVideos'].length + 1,
            src: '',
            srcCopy: '',
            title: '周边视频',
            type: 'infoVideos',
            tracks: [],
            start_time: '',
            end_time: '',
            text: '',
            poster: 'https://img1.baidu.com/it/u=2781281637,4119398334&fm=253&fmt=auto&app=138&f=JPEG?w=80&h=80'
        })
    }
}
const recivePicPathGetUrl = (url, index, typeKey) => {
    // let key = url.split(".com/")[1];
    // const judge = url.indexOf('ishare-10003415')
    const url2 = url.includes('http') ? url : `https://${url}`
    window.getReadOnlyPresignedUrlApi(url2).then(resUrl => {
        data.formData[typeKey].map((item, mapIndex) => {
            if (item.type === typeKey && mapIndex == index) {
                item.src = resUrl
            }
        })
        if(typeKey == 'infoVideos'){
            infoVideos.value.logList(resUrl, index)
        }
    })
}
// 获取预览状态
const getShowPreviewImg = val => {
    data.showPreviewImg = val;
};
const backEvent = () => {
    router.go(-1)
}
const dialogCancle = () => {
    store.dispatch("setMessageAppearDetailVisble", false);
};
const dialogOk = () => {
    data.isAllowExit = true
    store.dispatch("setMessageAppearDetailVisble", false);
    router.go(-1);
};
onBeforeRouteLeave((to, from) => {
    infoVideos.value.showPopupHidden()
    if (!data.isAllowExit) {
        if (data.showPreviewImg) {
            data.showPreviewImg = false;
            data.showPreviewVideo = false;
            return false;
        }
        const { href, params } = from;
        console.log(href.includes("staff_report") &&
            params.from === 'index' && data.loading == false);
        if (
            href.includes("staff_report") &&
            params.from === 'index' && data.loading == false
        ) {
            store.dispatch("setMessageAppearDetailVisble", true);
            return false;
        }
    }
})
</script>
<style lang='scss' scoped>
input{
    outline: none;
    caret-color: #0077ff;
}
.mgTp4 {
    margin-top: 4px;
}
.mgTp6 {
    margin-top: 6px;
}
.mgTp16 {
    margin-top: 16px;
}
.mgTp20 {
    margin-top: 20px;
}
.mgTp24 {
    margin-top: 24px;
}
.mbBm13 {
    margin-bottom: 13px;
}
.redPoint{
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #ff4433;
    vertical-align: top;
    position: relative;
    top: 3px;
}
.inputPublicCss{
    border: none;
    display: block;
    width: 100%;
    font-size: 14px;
    border-bottom: 0.5px solid rgba($color: #17181a, $alpha: 0.15);
    color: #17181a;
    &::placeholder{
        color: #c8c9cc;
    }
    &:disabled{
        background-color: #fff;
    }
}
@media all and (max-width: 330px) {
    .inputPublicCss{
        & ::placeholder{
            width: 100%;
            font-size: 12px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
.wrapper {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    z-index: 555;
}
.auditNoPass {
    margin-right: 0;
    height: 44px;
    background: rgb(255, 68, 51, 0.08);
    display: flex;
    align-items: center;
    img {
      width: 16px;
      height: 16px;
      margin-left: 20px;
    }
    div {
      display: inline-block;
      margin-left: 5px;
      font-family: NotoSansCJKsc-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #ff4433;
    }
}

.batch_header{
    padding: 35px 0 10px;
    position: relative;
    box-shadow: 0px 2px 14px rgba(0, 136, 255, $alpha: 0.08);
    img{
        position: absolute;
        top: 35px;
        left: 20px;
        width: 20px;
        height: 20px;
    }
    div{
        text-align: center;
        font-size: 16px;
        font-weight: 700;
    }
}

.batch_report_box{
    padding: 0 20px;
    .detail_title {
        font-size: 16px;
        font-weight: bold;
        opacity: 0.9;
        font-family:Arial, Helvetica, sans-serif;

    }
    .description_textarea{
        font-weight: 500;
        font-size: 14px;
        opacity: 0.7;
        color: #17181a;
    }
    .wayPassStatus {
        & > div{
            display: flex;
            justify-content: space-around;
            // button:nth-child(1){
            //     padding: 0 22px;
            // }
            // button:nth-child(1){
            //     padding: 0 15px;
            // }
            button:nth-child(3){
                // padding: 0 8px;
                margin-right: 0px;
            }
        }
        .card--active {
            border-color: #0052d9;
        }
        .card--active::after {
            content: '';
            display: block;
            position: absolute;
            right: 0;
            top: 0;
            width: 0;
            border: 12px solid #0052d9;
            border-bottom-color: transparent;
            border-left-color: transparent;
            border-radius: 0 3Px 0;
        }
        & button {
            position: relative;
            width: 33%;
            height: 38px;
            border-radius: 4px;
            font-weight: 500;
            font-size: 16Px;
            text-align: center;
            line-height: 38px;
            margin-right: 10px;
            font-family:Arial, Helvetica, sans-serif;
            .card__icon {
                color: #fff;
                position: absolute;
                right: 1.5px;
                top: 0px;
                z-index: 1;
            }
        }
        & .defaultBtn {
            color: #000000;
            border: 1px solid rgba($color: #17181a, $alpha: 0.15);
            background: rgba($color: #fff, $alpha: 0.15);
        }
        & .activeBtn {
            background: #e5f3ff;
            border: 1px solid #0088ff;
            color: #0088ff;
        }
    }
    .locationGet {
        font-size: 14px;
        height: 52px;
        line-height: 52px;
        position: relative;
        .del_icon{
            position: absolute;
            right: 20px;
            top: 19px;
        }
    }
    .locationGetHui {
        color: #c8c9cc;
    }
    .advise_photo_info {
        font-size: 14px;
        color: #17181a;
        opacity: 0.7;
        font-weight: 500;
        text-align: justify;
    }
    .goOnInfo {
        width: 96%;
        height: 100px;
        margin-bottom: 150px;
        //opacity: 0.6;
        background: #F6F6F9;
        border-radius: 4px;
        outline: none;
        border: none;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        padding: 10px 10px 0px;
        color:black;
    }
    .appeared {
        position: fixed;
        width: 100%;
        left: 0;
        bottom: 0;
        padding: 19px 0;
        text-align: center;
        background-color: #fff;
        box-shadow: 0 -4px 10px 0 rgba(0, 0, 0, 0.05);
        z-index: 1000;
        & button {
            width: 90%;
            padding: 13px 0;
            border: none;
            background-color: #e5f3ff;
            border-radius: 38px;
            font-weight: Bold;
            font-size: 16px;
            color: #fff;
            text-align: center;
            line-height: 16px;
            -webkit-tap-highlight-color: rgb(0, 0, 0, 0);
            -webkit-tap-highlight-color: transparent;
            outline: none;
        }

        .complete {
            background-color: #0088ff;
        }
    }
    .showFillinBtn{
        display: block;
    }
    .hiddenFillinBtn{
        display: none;
    }
}
@media all and (max-width: 308px) {
    .wayPassStatus button{
        margin-right: 3px !important;
    }
}
.dialogObscuration {
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1111;

    .dialogImg {
        background: url("../../assets/image_message_appear/messageAppearDetail.png");
        background-size: 320px 171px;
        width: 320px;
        height: 171px;
        position: fixed;
        top: 50%;
        margin-top: -85px;
        left: 50%;
        margin-left: -160px;

        span {
            display: inline-block;
            position: absolute;
            width: 92px;
            height: 42px;
            bottom: 20px;
            border-radius: 21px;
        }

        span:nth-of-type(1) {
            right: 112px;
        }

        span:nth-of-type(2) {
            right: 20px;
        }
    }
}
.wrapper_overlay {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    color: white;
    .content {
        display: flex;
        width: 85%;
        height: 60px;
        background: #fff;
        border-radius: 8px;
        align-items: center;
        justify-content: center;
        color: red;
        font-size: 14px;
    }
}
@media screen and (max-width: 360px){
    .batch_report_box .wayPassStatus button{
        font-size: 14Px;
    }
}
@media screen and (max-width: 320px){
    .batch_report_box .wayPassStatus button{
        font-size: 12Px;
    }
}
// @media screen and (max-width: 450px){
//     .batch_report_box .wayPassStatus button{
//         font-size: 12Px;
//     }
// }
// @media screen and (max-width: 300px){
//     .batch_report_box .wayPassStatus button{
//         font-size: 10Px;
//     }
// }
</style>